module.exports = __webpack_public_path__ + "static/media/phone-icon.e480188d.svg";